module.exports = __webpack_public_path__ + "static/media/zm.0dcbc90e.svg";